








import { DropdownField, FormDef, FormField, FormFieldGroup, FormValue } from '@/app_code/Forms'
import Checkbox from '@/components/UI/Elements/Forms/Checkbox.vue'
import Form from '@/components/UI/Elements/Forms/Form.vue'
import { EnumerationValueModel, RequestValuationModel } from 'truemarket-modules/src/models/api'
import EnumValueType from 'truemarket-modules/src/models/api/enumerations/EnumValueType'
import { Services } from 'truemarket-modules/src/services'
import { Component, Prop, Vue } from 'vue-property-decorator'
import IValuationFormStep from '@/components/Valuation/IValuationFormStep'

@Component({
  components: {
    Form
  }
})
export default class ResidentialDetatchedResidenceDetails extends Vue implements IValuationFormStep {
  fields: FormDef | null = null

  loading = true

  errored = false

  @Prop()
  private readonly model!: RequestValuationModel

  private enumVals: EnumerationValueModel[][] = []

  public collectData (): FormValue[] {
    return (this.$refs.mainForm as Form).GetValues().Fields
  }

  mounted (): void {
    const promises = [
      Services.API.Enumerations.GetEnumValuesForType(EnumValueType.FloorConstructionType), // 0
      Services.API.Enumerations.GetEnumValuesForType(EnumValueType.WallConstructionType), // 1
      Services.API.Enumerations.GetEnumValuesForType(EnumValueType.RoofConstructionType), // 2
      Services.API.Enumerations.GetEnumValuesForType(EnumValueType.ResidentialPropertyFeatures), // 3
      Services.API.Enumerations.GetEnumValuesForType(EnumValueType.PropertyCondition), // 4
      Services.API.Enumerations.GetEnumValuesForType(EnumValueType.CityViews), // 5
      Services.API.Enumerations.GetEnumValuesForType(EnumValueType.RiverViews), // 6
      Services.API.Enumerations.GetEnumValuesForType(EnumValueType.ElevatedOutlook), // 7
      Services.API.Enumerations.GetEnumValuesForType(EnumValueType.Pool), // 8
      Services.API.Enumerations.GetEnumValuesForType(EnumValueType.TennisCourt), // 9
      Services.API.Enumerations.GetEnumValuesForType(EnumValueType.SecureParkingSpaces), // 10
      Services.API.Enumerations.GetEnumValuesForType(EnumValueType.Bedrooms), // 11
      Services.API.Enumerations.GetEnumValuesForType(EnumValueType.Bathrooms), // 12
      Services.API.Enumerations.GetEnumValuesForType(EnumValueType.Parking), // 13
      Services.API.Enumerations.GetEnumValuesForType(EnumValueType.AirConditioningType) // 14
    ]

    Promise.all(promises).then((vals) => {
      this.loading = false

      this.enumVals = vals

      this.fields = [
        new FormFieldGroup({
          Key: 'DetatchedResidenceDetails',
          Title: 'Detatched Residence Details',
          ShowTitle: true,
          Fields: [
            new DropdownField({
              Key: 'Residential_GeneralCondition',
              Label: 'General Condition:',
              Placeholder: 'Please Select',
              Items: vals[4].map((v) => ({ Label: v.Label, Key: v.ValueId })),
              Required: true
            }),
            new DropdownField({
              Key: 'Residential_FloorConstruction',
              Label: 'Floors:',
              Placeholder: 'Please Select',
              Items: vals[0].map((v) => ({ Label: v.Label, Key: v.ValueId })),
              Required: true
            }),
            new DropdownField({
              Key: 'Residential_WallConstruction',
              Label: 'Walls:',
              Placeholder: 'Please Select',
              Items: vals[1].map((v) => ({ Label: v.Label, Key: v.ValueId })),
              Required: true
            }),
            new DropdownField({
              Key: 'Residential_RoofConstruction',
              Label: 'Roof:',
              Placeholder: 'Please Select',
              Items: vals[2].map((v) => ({ Label: v.Label, Key: v.ValueId })),
              Required: true
            }),
            new FormField({
              Key: 'Residential_ApproximateBuildYear',
              Label: 'Approximate Building Year:',
              Placeholder: '(eg 1990s)',
              Required: false
            }),
            new FormField({
              Key: 'Residential_EstimatedValue',
              Label: 'Estimated Value / Current Book Value:',
              Placeholder: '',
              Required: false
            }),
            new FormField({
              Key: 'Residential_CurrentRental',
              Label: 'Current Rental:',
              Placeholder: '',
              Required: false
            }),
            new DropdownField({
              Value: '',
              Key: 'Residential_NumberOfBedrooms',
              Label: 'Bedrooms:',
              Placeholder: 'Please Select',
              Items: vals[11].map((v) => ({ Label: v.Label, Key: v.ValueId })),
              Required: true
            }),
            new DropdownField({
              Value: '',
              Key: 'Residential_NumberOfBathrooms',
              Label: 'Bathrooms:',
              Placeholder: 'Please Select',
              Items: vals[12].map((v) => ({ Label: v.Label, Key: v.ValueId })),
              Required: true
            }),
            new DropdownField({
              Value: '',
              Key: 'Residential_CarParks',
              Label: 'Car Parking:',
              Placeholder: 'Please Select',
              Items: vals[13].map((v) => ({ Label: v.Label, Key: v.ValueId })),
              Required: true
            }),
            new FormField({
              Key: 'Residential_FloorArea',
              Label: 'Internal Floor Area:',
              Placeholder: 'e.g. 100 m²',
              Required: false
            }),
            new FormField({
              Key: 'Residential_Other',
              Label: 'Other:',
              Placeholder: 'e.g. Architecturally Designed, Recently Renovated, Heritage Listed, etc',
              Required: false
            })
          ]
        }),
        new FormFieldGroup({
          Key: 'Residential_PropertyFeatures',
          Title: 'Property Features',
          ShowTitle: true,
          Fields: [
            ...(vals[3].map((v) => new FormField({ Key: 'Residential_PropertyFeatures', Value: v.ValueId, Composite: true, Label: v.Label, Type: 'checkbox' })))
          ]
        })
      ]
    })
  }
}
